import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'elementsInfo',
  standalone: true,
})
export class ElementsInfoPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any[], key: string, emptyText = 'Sin elementos'): string {
    const name = value.length > 0 && value[0][key] ? value[0][key] : emptyText;
    if (value.length > 1) {
      return `${name} y ${value.length - 1} más`;
    }
    return name;
  }
}
